import React, { useEffect, useState } from "react";

import {
    getSmartTVMediaTraceSnapshot,
    subscribeSmartTVMediaTrace,
    updateSmartTVMediaTraceStatus
} from "../../../lib/SmartTVMediaTrace";

const SmartTVMediaTraceOverlay = ({ isRbmqServerConnected, isReadyLiveConsume, memberCount }) => {
    const [snapshot, setSnapshot] = useState(getSmartTVMediaTraceSnapshot());
    const [isDetailOpened, setIsDetailOpened] = useState(false);

    useEffect(() => subscribeSmartTVMediaTrace(setSnapshot), []);

    useEffect(() => {
        // 260806 공용 transport는 학생별이 아닌 연결당 상태로 진단 오버레이에 표시한다.
        updateSmartTVMediaTraceStatus({
            isRbmqServerConnected,
            isReadyLiveConsume,
            memberCount
        });
    }, [isRbmqServerConnected, isReadyLiveConsume, memberCount]);

    if (!snapshot.isEnabled) return null;

    return (
        <div className={`smart-tv-media-trace-overlay${isDetailOpened ? " detail" : ""}`} onClick={() => setIsDetailOpened(value => !value)}>
            <div>TRACE {snapshot.traceSessionId}</div>
            <div>RBMQ {snapshot.isRbmqServerConnected ? "ON" : "OFF"} / TRANSPORT {snapshot.isReadyLiveConsume ? "READY" : "WAIT"}</div>
            <div>PLAYING {snapshot.playingCount}/{snapshot.memberCount} / BUFFER {snapshot.bufferCount} / PENDING {snapshot.pendingCount}</div>
            <div>LAST {snapshot.lastStage || "-"} / ERROR {String(snapshot.lastError || "-")}</div>
            {isDetailOpened && (
                <React.Fragment>
                    <div>SUCCESS USER {snapshot.lastSuccessUserSeq} / FAILED USER {snapshot.lastFailedUserSeq}</div>
                    <div>SENT {snapshot.sentCount} / SENDING {snapshot.isSending ? "Y" : "N"}</div>
                    <div>LAST SENT {snapshot.lastSentAt || "-"}</div>
                    <div>LAST ACK {snapshot.lastAckAt || "-"}</div>
                </React.Fragment>
            )}
        </div>
    );
};

export default SmartTVMediaTraceOverlay;

